var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddMember = function SvgAddMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.779A8 8 0 1 1 4.037 7.445",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 3 1.185 1.778 2.37-1.185L12.964 7H7.037l-.593-3.407 2.37 1.185L10 3ZM10 14.556a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333ZM15 18.388a3.557 3.557 0 0 0-3.222-2.054H8.222A3.556 3.556 0 0 0 5 18.388M16 6h6M19 3v6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAddMember;